import { toast } from "sonner";

const KEY = "kh_last_backup";
const WEEK = 7 * 24 * 60 * 60 * 1000;

export function lastBackupAt() {
  const v = parseInt(localStorage.getItem(KEY) || "0", 10);
  return v || null;
}

export function isBackupDue() {
  const last = lastBackupAt();
  if (!last) return true;
  return Date.now() - last > WEEK;
}

export function markBackupDone() {
  localStorage.setItem(KEY, String(Date.now()));
}

export function snoozeBackup() {
  // snooze 1 day by pretending backup happened 6 days ago
  localStorage.setItem(KEY, String(Date.now() - (WEEK - 24 * 60 * 60 * 1000)));
}

export function exportBackup(data, pid) {
  const backup = {
    app: "Wedifylab",
    exported_at: new Date().toISOString(),
    pasangan_id: pid,
    data,
  };
  const blob = new Blob([JSON.stringify(backup, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `kh-backup-${pid || "data"}-${new Date().toISOString().slice(0, 10)}.json`;
  a.click();
  URL.revokeObjectURL(url);
  markBackupDone();
  toast.success("Backup data (JSON) diunduh");
}
